<template>
    <PopoverRight ref="popoverContent" width="700px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑用户黑名单</h1>
            <div class="tips-wrapper clearfix">
                <div class="left">提示：</div>
                <div class="right">
                    <p>1.用户黑名单中的用户报名时，线索会进入线索列表但会标记为黑名单状态，不会推送线索至好房云平台。</p>
                    <p>2.同步会限制该用户的IM聊天功能，无法对限制站点的经纪人发起IM咨询。</p>
                </div>
            </div>
            <el-form class="form-container" :rules="rules" :model="formList" ref="blackValidateForm"> 
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">手机号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="mobile">
                            <el-input  v-model="formList.mobile" disabled></el-input>                   
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item site-sp" >
                    <div class="site-label">
                        <span class="label">限制站点：</span>
                        <label class="warn">*</label>
                        <label class="ipt"
                        ><input
                            type="checkbox"
                            class="checkbox"
                            @click="selectAll"
                            :checked="checkAll"
                        />全选</label
                        >
                    </div>
                    <br />
                    <div class="form-input-site">
                        <div v-if="this.siteList.length > 0">
                        <label v-for="(item, key) in siteList" :key="key">
                            <input
                            :id="key"
                            type="checkbox"
                            :value="item.id"
                            v-model="checkedSite"
                            />{{ item.name }}
                        </label>
                        </div>
                        <div v-else>暂无数据</div>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">原因</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="remark">
                            <el-input type="textarea" :rows="2" v-model="formList.remark" placeholder="请输入拉黑原因（150个字以内）"></el-input>                   
                        </el-form-item>
                    </div>
                </div>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('blackValidateForm')" >确定</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { getSite } from "@/service/site";
import { parseTime } from '@/utils'
import {getUserBlackDetail,editUserBlack} from '@/service/blackModel'
import {validateMobile} from '@/utils/validate'
export default {
    name: 'edit',
    components: {
        PopoverRight,
    },
    props: {
        callback: Function,
    },
    data () {
        return {
            pickerOptions: {
                disabledDate(time) {
                　  return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                }
            },
            checkAll: false,
            siteList: [],
            checkedSite: [],
            formList:{
                mobile:"",
                site_ids:"",
                remark:'',
                source_id:1,
            },

            rules: {
                remark: [
                    { required: true, message:'拉黑原因不能为空', trigger: 'blur' },
                    { min:0,max:150,message:'可输入150个字符',trigger: "blur"}
                ],
                mobile:[
                    { required: true, message:'手机号码不能为空', trigger: 'blur' },
                    { validator: validateMobile,result:"手机号码",trigger: "blur"}
                ]
               
            },
            user:""
        }
    },
    watch: {
        checkedSite: function () {
        if (
            this.checkedSite.length == this.siteList.length &&
            this.checkedSite.length > 0
        ) {
            this.checkAll = true;
        } else {
            this.checkAll = false;
        }
        },
    },

    mounted(){
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
            getUserBlackDetail(id).then(res => {
                this.formList = res
                if(res.site_ids === "0"){
                    this.checkedSite = this.siteList.map(item => {
                        return item.id
                    })
                }else{
                    this.checkedSite = res.site_ids.split("_")
                }
            })
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        selectAll(event) {
            var _this = this;
            if (!event.currentTarget.checked) {
                this.checkedSite = [];
            } else {
                _this.checkedSite = [];
                _this.siteList.forEach(function (item) {
                _this.checkedSite.push(item.id);
                });
            }
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.resetForm()
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.blackValidateForm && this.$refs.blackValidateForm.clearValidate()
        },
        resetForm () {
            this.formList = {
                mobile:"",
                site_ids:"",
                remark:'',
                source_id:1,
            }
            this.checkedSite = [];
        },
        submitForm (formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    if(this.checkedSite.length<=0){
                        this.$message({
                            type: "error",
                            message: "请选择站点",
                        });
                        return;
                    }
                    let query = this.formList;
                    if (
                        this.checkedSite.length == this.siteList.length &&
                        this.checkedSite.length > 0
                    ) {
                        query.site_ids = "0"
                    }else{
                        query.site_ids =this.checkedSite.join("_");
                    }
                    editUserBlack(query.id,query).then((data) => {
                        this.$message({
                            message: '编辑成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                        this.hideMenu()
                        this.callback && this.callback();
                    }).catch(err => {
                        this.$message({
                            message: err.message || '编辑失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                    
                } else {
                    return false
                }
            })
        },
    }
}
</script>
<style scoped>
.site-sp {
  display: block !important;
  padding-left: 30px;
}
.site-label {
  width: 100%;
  height: 30px;
}
.site-label .ipt {
  margin-right: 20px;
}
.form-input-site {
  min-height: 100px;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 20px;
  box-sizing: border-box;
}
.form-input-site label {
  margin-right: 15px;
  padding-bottom: 10px;
  display: inline-block;
}
.form-input-site label input {
  margin-right: 5px;
}
.popover-slider-bar .form-container .form-item .form-label {
    width: 15%;
}
.popover-slider-bar .form-container .form-item .form-input-item {
    width: 75%;
}
.tips-wrapper{
    width: 100%;
    margin-top:20px;
}
.tips-wrapper .left{
    width: 15%; 
    float: left;
    text-align: right;
    line-height:30px;
}
.tips-wrapper .right{
     float: left;
     width:85%;
}
.tips-wrapper .right p{
    line-height: 30px;
}
</style>